import classNames from 'classnames/bind';

import styles from './S04.module.scss';

const cx = classNames.bind(styles);

const S03 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <div className={cx('box')}>
          <div className={cx('title')}>
            <span>풀무원 하루귀리</span>가
            <br />
            생각나는 순간?
          </div>
          <div className={cx('grid')}>
            <div className={cx('item')}>
              <img src={require('../../../assets/images/products/oneday/s04/icon-01.png')} alt="" />
              <div className={cx('desc')}>아침에 일어났을 때</div>
            </div>
            <div className={cx('item')}>
              <img src={require('../../../assets/images/products/oneday/s04/icon-02.png')} alt="" />
              <div className={cx('desc')}>출/퇴근, 등/하교할 때</div>
            </div>
            <div className={cx('item')}>
              <img src={require('../../../assets/images/products/oneday/s04/icon-03.png')} alt="" />
              <div className={cx('desc')}>운동 시 갈증날 때</div>
            </div>
            <div className={cx('item')}>
              <img src={require('../../../assets/images/products/oneday/s04/icon-04.png')} alt="" />
              <div className={cx('desc')}>식사 중 목이 마를 때</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default S03;
